var _style, _path, _path2, _path3, _rect, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSesameOil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B9CFC0;}\n\t.st1{fill:#F0C15E;}\n\t.st2{fill:#29384F;}\n\t.st3{fill:#EADC9D;}\n\t.st4{fill:#EFE7AD;}\n\t.st5{fill:none;stroke:#F8EEE1;stroke-width:4.1101;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.75,185.55c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C27.45,151.26,62.06,185.55,104.75,185.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.11,53.83H93.39c-0.67,0-1.29,0.24-1.69,0.65c-3.61,3.73,3.74,10.62,5.26,11.96 c0.4,0.36,0.98,0.56,1.59,0.56h12.4c0.61,0,1.19-0.2,1.59-0.56c1.51-1.34,8.87-8.23,5.26-11.96 C117.4,54.07,116.77,53.83,116.11,53.83z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.75,85.5c1.98,0.84,3.6,2.94,3.6,4.67v68.99c0,1.73-1.85,3.15-4.11,3.15H84.27c-2.26,0-4.11-1.42-4.11-3.15 V90.18c0-1.73,1.62-3.83,3.6-4.67l7.69-3.25c1.98-0.84,3.6-2.94,3.6-4.67v0.2c0-1.73-1.48-3.15-3.29-3.15 c-1.81,0-3.29-1.42-3.29-3.15v-4.6c0-1.73,1.85-3.15,4.11-3.15h24.39c2.26,0,4.11,1.42,4.11,3.15v4.6c0,1.73-1.48,3.15-3.29,3.15 c-1.81,0-3.29,1.42-3.29,3.15v-0.2c0,1.73,1.62,3.83,3.6,4.67L125.75,85.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.21,
    y: 95.28,
    className: "st1",
    width: 41.08,
    height: 62.24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.29,133.82c-1.35,8.9-8.76,15.15-16.54,13.97c-7.78-1.18-12.99-9.36-11.64-18.26 c1.35-8.9,12.85-24.7,20.63-23.52C119.52,107.19,120.64,124.92,119.29,133.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.67,132.06c-1.35,8.9-8.76,15.15-16.54,13.97s-12.99-9.36-11.64-18.26s12.85-24.7,20.63-23.52 S119.02,123.17,117.67,132.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.12,121.19c-2.87,5.22-5.22,18.8,5.05,22.53"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105,110.7c-0.02-1.45,0.6-2.9,1.67-3.89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSesameOil);
export default __webpack_public_path__ + "static/media/Sesame_oil.a2d703888b6aba136a8e36629d7eb785.svg";
export { ForwardRef as ReactComponent };